//@ts-nocheck
'use client'

import React, { useContext } from 'react'

import { Heading, Paragraph } from '../../../atoms/Typography/Typography.component'
import { SpacerBase, Visible } from '../../../atoms/GridSystem'
import Icon from '../../../atoms/Icon/Icon.component'
import ItemsGrouped from '../../../molecules/ItemsGrouped/ItemsGrouped.component'
import Button from '../../../atoms/Button/Button.component'
import { SectionThemeContext } from '../../../../contexts/SectionTheme.context'

import * as S from '../Text.styles'

interface TextQuoteProps {
  author?: string
  quote?: string
  colorScheme?: string,
  ctaPrimary?: string
}

const TextQuote: React.FC<TextQuoteProps> = ({ author, quote, ctaPrimary, colorScheme, withBackground }) => {
  const { selectedColorScheme } = useContext(SectionThemeContext)

  return (
    <S.TextQuoteWrapper>
      {quote ? (
        <S.TextQuoteInner colorScheme={colorScheme || selectedColorScheme}>
          <Icon name={'quote-open'} />
          <Heading as="h3" typo="displayXS" content={quote} fontPrimary />
        </S.TextQuoteInner>
      ) : null}
      { author || ctaPrimary ? (
        <S.TextQuoteBottom>
          <ItemsGrouped 
            direction={{ xs: 'column', lg: 'row' }} 
            justify={{ xs: 'initial', lg: 'space-between' }}
            align={{ xs: 'flex-start', lg: 'initial' }}
            space={{ xs: 20, lg: 0 }}
          >
            {author ? (
              <S.TextQuoteAuthor colorScheme={colorScheme || selectedColorScheme} withBackground={withBackground}>
                <ItemsGrouped direction={'column'} align={'flex-start'}>
                  <Paragraph typo="headingXS" content={author.name} />
                  { author.role ? <Paragraph typo="paragraphMD" content={author.role} /> : null}
                </ItemsGrouped>
              </S.TextQuoteAuthor>
            ) : null}
            { ctaPrimary ? (
              <Button {...ctaPrimary} variant="primary" iconEnd="arrow-right" />
            ) : null}
          </ItemsGrouped>
        </S.TextQuoteBottom>  
      ) : null}
    </S.TextQuoteWrapper>
  )
}

export default TextQuote
